export type ResolutionRejectionLabels = {
  title?: string
  subjectLabel?: string
  reasonLabel?: string
  reasonPlaceholder?: string
  reasonRequiredText?: string
  caseText?: string
  confirmLabel?: string
  cancelLabel?: string
}

export type ResolutionConfig = {
  message?: string
  acceptLabel?: string
  rejectLabel?: string
  errorText?: string
  errorSubtext?: string
  successText?: string
  rejectionLabels?: ResolutionRejectionLabels
}

export type CancelConfig = {
  message?: string
  subtext?: string
  yesLabel?: string
  noLabel?: string
}

export type CopCaseDetailsProps = {
  title?: string
  sectiontype?: string
  layout?: string
  labels?: string

  tab1Label?: string
  tab2Label?: string
  tab3Label?: string
  addCommentLabel?: string
  popupTitle?: string
  popupDescription?: string
  popupTextareaPlaceholder?: string
  popupCharacterLimit?: string
  popupFileHelpText?: string
  popupCancelLabel?: string
  popupShareLabel?: string
  popupCommentRequiredError?: string
  popupFileTypeError?: string
  popupFileSizeError?: string
  popupFileRequiredError?: string
  popupSubmitSuccessMessage?: string
  popupSubmitErrorMessage?: string
  popupSelectFileLabel?: string
  popupNoFileSelectedLabel?: string
  popupCancelConfirmMessage?: string
  popupCancelConfirmYesLabel?: string
  popupCancelConfirmNoLabel?: string
  accordionLabels?: string

  colLastModifiedBy?: string
  colDate?: string
  colComments?: string
  colAttachments?: string
  colViewDownload?: string
  viewLabel?: string
  downloadLabel?: string
  noCommentsLabel?: string
  numberOfCommentsLabel?: string
  itemsPerPageLabel?: string
  loadingLabel?: string
  fileDownloadErrorLabel?: string

  resolvedBannerMessage?: string
  resolvedBannerRejectLabel?: string
  resolvedBannerAcceptLabel?: string
  approveSuccessMessage?: string
  approveErrorMessage?: string
  rejectSuccessMessage?: string
  rejectErrorMessage?: string
  resolutionconfig?: string
  cancelconfig?: string

  rejectModalTitle?: string
  rejectModalHelpText?: string
  rejectModalPlaceholder?: string
  rejectModalCharLimit?: string
  rejectModalCancelLabel?: string
  rejectModalSendLabel?: string

  // ── Lowercase AEM attribute variants ────────────────────────────────────
  resolvedBannermessage?: string
  resolvedBannerrejectlabel?: string
  resolvedBanneracceptlabel?: string
  approvesuccessmessage?: string
  approveerrormessage?: string
  rejectsuccessmessage?: string
  rejecterrormessage?: string

  rejectmodaltitle?: string
  rejectmodalhelptext?: string
  rejectmodalplaceholder?: string
  rejectmodalcharlimit?: string
  rejectmodalcancellabel?: string
  rejectmodalsendlabel?: string

  tab1label?: string
  tab2label?: string
  tab3label?: string
  addcommentlabel?: string
  popuptitle?: string
  popupdescription?: string
  popuptextareaplaceholder?: string
  popupcharacterlimit?: string
  popupfilehelptext?: string
  popupcancellabel?: string
  popupsharelabel?: string
  popupcommentrequirederror?: string
  popupfiletypeerror?: string
  popupfilesizeerror?: string
  popupfilerequirederror?: string
  popupsubmitsuccessmessage?: string
  popupsubmiterrormessage?: string
  popupselectfilelabel?: string
  popupnofileselectedlabel?: string
  popupcancelconfirmmessage?: string
  popupcancelconfirmyeslabel?: string
  popupcancelconfirmnolabel?: string
  accordionlabels?: string
  collastmodifiedby?: string
  coldate?: string
  colcomments?: string
  colattachments?: string
  colviewdownload?: string
  viewlabel?: string
  downloadlabel?: string
  nocommentslabel?: string
  numberofcommentslabel?: string
  itemsperpagelabel?: string
  loadinglabel?: string
  filedownloaderrorlabel?: string
}

export type HeaderLabel = {
  labelText: string
  dataKey: string
}

export function parseLabels(labels?: string): HeaderLabel[] {
  if (!labels) return []
  try {
    const parsed = JSON.parse(labels)
    if (!Array.isArray(parsed)) return []
    return parsed
      .map((item): HeaderLabel | null => {
        if (typeof item === 'string') {
          return { labelText: item, dataKey: item }
        }
        if (item && typeof item === 'object') {
          const labelText = typeof item.labelText === 'string' ? item.labelText.trim() : ''
          const dataKey = typeof item.dataKey === 'string' ? item.dataKey.trim() : ''
          if (labelText) {
            return { labelText, dataKey }
          }
        }
        return null
      })
      .filter((entry): entry is HeaderLabel => entry !== null)
  } catch {
    return []
  }
}
